module.exports = __webpack_public_path__ + "img/BM.05c8cc43.png";